import Vue from 'vue'
import Router from 'vue-router'
import CreateEvent from './views/CreateEvent'
import ShowEvent from './views/ShowEvent'
import EditEvent from './views/EditEvent'
import Dashboard from './views/Dashboard'
import Home from './views/Home'
import SignIn from './views/SignIn'
import SignOut from './views/SignOut'
import Register from './views/Register'
import Profile from './views/Profile'
import store from './store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/signin',
      name: 'signin',
      component: SignIn
    },
    {
      path: '/signout',
      name: 'signout',
      component: SignOut
    },
    {
      path: '/register',
      name: 'register',
      component: Register
    },
    {
      path: '/profile',
      name: 'profile',
      component: Profile,
      meta: {
        authRequired: true
      }
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
      meta: {
        authRequired: true
      }
    },
    {
      path: '/create-event',
      name: 'createEvent',
      component: CreateEvent,
      meta: {
        authRequired: true
      }
    },
    {
      path: '/event/:eventId',
      name: 'showEvent',
      component: ShowEvent
    },
    {
      path: '/event/:eventId/edit',
      name: 'editEvent',
      component: EditEvent
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.authRequired)) {
    if (!store.state.user) {
      next({
        path: '/signin',
        query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router